import { WebSocketConnector } from 'components/features/webSocket/WebSocketConnector'
import { publicSocketUrl } from 'constants/webSocket'
import { Subject } from 'rxjs'
import { delay, takeUntil, tap } from 'rxjs/operators'
import { deviceAppStateSelector } from 'selectors/deviceSelector'
import { getStore } from 'store'
import { consoleApi } from 'components/features/webSocketLogger/ConsoleApi'
import { onBreadcrumb$ } from 'helpers/errorHelpers'
import moment from 'moment'
import { captureException } from 'raven-js'

const AUTOSTART_PERMANENT_KEY = 'ConsoleWSRelayAutostartExpire'

class ConsoleWSRelay {
  private stop$ = new Subject<null>()
  private connector: WebSocketConnector<any, any> | null = null
  public meta: any = {}

  constructor () {
    this.autostart()
  }

  setMeta (meta: any) {
    this.meta = meta
  }

  get isStarted () {
    return !!this.connector
  }

  private autostart () {
    const autostartUntil = localStorage[AUTOSTART_PERMANENT_KEY] || ''
    if (!autostartUntil) {
      return
    }

    if (moment().isAfter(autostartUntil)) {
      return
    }

    this.start()
    console.log('ConsoleWSRelay autostart')
  }

  startPermanent () {
    this.start()
    try {
      localStorage[AUTOSTART_PERMANENT_KEY] = moment().add(30, 'minutes').toISOString()
    } catch (e) {
      captureException(e)
    }
  }

  start () {
    if (this.connector) {
      return
    }

    const connector = this.connector = new WebSocketConnector<any, any>(publicSocketUrl)
    consoleApi.onEvent$.pipe(
      takeUntil(this.stop$),
      delay(1),
    ).subscribe((event) => {

      const safeEvent = (() => {
        try {
          JSON.stringify(event.args)
          return event
        } catch (e) {}

        try {
          const safeArgs = Object.entries(event.args).reduce<any>((acc, [key, value]) => {
            const strValue = `${ value }`
            // tslint:disable-next-line
            if (strValue == value) {
              acc[key] = value
            } else {
              acc[key] = strValue
            }
            return acc
          }, {})

          return {
            ...event,
            args: safeArgs,
          }
        } catch (e) {}


        return {
          ...event,
          args: 'CAN\'T SERIALIZE',
        }

      })()

      connector.send({
        event: 'write_logs',
        data: {
          message: {
            ...safeEvent,
            meta: {
              ...deviceAppStateSelector(getStore().getState()),
              location: `${ location }`,
              ...this.meta,
            },
          },
        },
      })
    })

    onBreadcrumb$.pipe(
      takeUntil(this.stop$),
      tap((crumb) => {
        if (crumb?.category === 'console') {
          return
        }

        consoleApi.onEvent$.next({
          method: 'crumb',
          args: crumb,
        })
      })
    ).subscribe()

    consoleApi.install()
  }

  stop () {
    this.stop$.next(null)
    if (!this.connector) {
      return
    }
    this.connector.disconnect()
    this.connector = null
  }
}

export const consoleRelay = new ConsoleWSRelay()
